import { useMutation } from '@tanstack/react-query';

import { notificationService } from 'services';

export const useDeleteAllNotifications = () => {
  const { mutateAsync: deleteNotifications } = useMutation({
    mutationFn: () => notificationService.deleteNotifications(),
  });

  return { deleteNotifications };
};
